import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { IR2BRewardConfig } from "@faire/web-api--source/indigofair/data/IR2BRewardConfig";
import { R2B_REWARD_CONFIG_220725 } from "@faire/web-api--source/indigofair/settings/R2B_REWARD_CONFIG_220725";

import {
  assignSetting,
  getSettingValueWithoutAssignment,
} from "@faire/retailer/settings/__internal__/getSetting";

const r2BRewardConfigDefault = IR2BRewardConfig.build({
  r2b_activation_amount: IFaireMoney.build({
    amount_cents: 50_00,
    currency: "USD",
  }),
  r2b_per_order_amount: IFaireMoney.build({
    amount_cents: 50_00,
    currency: "USD",
  }),
  r2b_consolation_amount: IFaireMoney.build({
    amount_cents: 10_00,
    currency: "USD",
  }),
  r2b_max_credits: IFaireMoney.build({
    amount_cents: 2000_00,
    currency: "USD",
  }),
  treatment: "treatment1A",
});

export const getSettingR2BAwardConfiguration = (): IR2BRewardConfig =>
  getSettingValueWithoutAssignment(
    R2B_REWARD_CONFIG_220725,
    r2BRewardConfigDefault
  );

export const assignSettingR2BAwardConfiguration = () => {
  assignSetting(R2B_REWARD_CONFIG_220725);
};
